module.exports = __webpack_public_path__ + "static/media/bank.4668baf7.png";